import './hibuSelect.scss';
import Select, {components} from 'react-select';
import React from 'react';
import {Option, SelectOnChange} from './select';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import classNames from 'clsx';

export type InputProps = {
    className?: string;
    id?: string;
    name?: string;
    onChange?: SelectOnChange;
    value?: Option;
    options?: Option[];
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <SvgIcon icon={Icons.DROP_DOWN} />
        </components.DropdownIndicator>
    );
};

export const HibuSelect = React.memo((props: InputProps) => {
    return (
        <>
            <Select
                className={classNames('react-select--inline', props.className)}
                classNamePrefix={'react-select'}
                components={{DropdownIndicator}}
                id={props.id}
                name={props.name}
                onChange={props.onChange}
                value={props.value}
                options={props.options}
                isSearchable={false}
            />
        </>
    );
});
